import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Actions from '../Actions';
import { Table, Tag, Typography, Card, Empty } from 'antd';

const { Title, Text } = Typography;

function ContactsView({ selectedShop, contacts = [], loading, actions }: any) {
  const shopId = selectedShop?.shopId;

  useEffect(() => {
    if (shopId) {
      actions?.fetchContacts(shopId);
    }
  }, [shopId]);

  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      render: (v: string) => <Text strong>{v}</Text>,
    },
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
      render: (v: string) => v || '—',
    },
    {
      title: 'Phone',
      dataIndex: 'phone',
      key: 'phone',
      render: (v: string) => v || '—',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
      render: (v: string) => v || '—',
    },
    {
      title: 'Address',
      dataIndex: 'addresses',
      key: 'addresses',
      // Same `addresses` shape the POS writes: [{id,label,address,isPrimary}].
      // Shows the primary address; a badge counts any additional ones.
      render: (v: any) => {
        const list = Array.isArray(v) ? v : [];
        if (list.length === 0) return '—';
        const primary = list.find((a: any) => a?.isPrimary) ?? list[0];
        return (
          <span>
            {primary?.label ? <Text type="secondary">{primary.label}: </Text> : null}
            {primary?.address || '—'}
            {list.length > 1 && (
              <Tag style={{ marginLeft: 6 }}>{`+${list.length - 1} more`}</Tag>
            )}
          </span>
        );
      },
    },
    {
      title: 'Status',
      dataIndex: 'isRestricted',
      key: 'isRestricted',
      render: (v: boolean) =>
        v ? (
          <Tag color="red">Restricted</Tag>
        ) : (
          <Tag color="green">Active</Tag>
        ),
    },
    {
      title: 'Linked Orders',
      dataIndex: 'linkedOrderIds',
      key: 'linkedOrderIds',
      render: (v: any) => (Array.isArray(v) ? v.length : 0),
    },
    {
      title: 'Added',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (v: string) =>
        v ? new Date(v).toLocaleDateString() : '—',
    },
  ];

  return (
    <div style={{ padding: '24px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 24 }}>
        <Title level={3} style={{ margin: 0 }}>Contacts</Title>
      </div>
      <Card>
        {contacts.length === 0 && !loading ? (
          <Empty description="No contacts synced yet." />
        ) : (
          <Table
            dataSource={contacts}
            columns={columns}
            rowKey="id"
            loading={loading}
            pagination={{ pageSize: 20 }}
            size="small"
          />
        )}
      </Card>
    </div>
  );
}

const mapStateToProps = (state: any) => ({
  selectedShop: state.dashboard.get('selectedShop'),
  contacts: state.complementary.get('contacts'),
  loading: state.complementary.get('loading'),
});

const mapDispatchToProps = (dispatch: any) => ({
  actions: bindActionCreators(Actions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactsView);
